import template from './searchForm.html';
import './searchForm.less';
import SearchFormController from './searchForm.controller';

const SearchFormComponent = {
  bindings: {
    tabs: '<',
    formData: '<'
  },
  template,
  controller: SearchFormController
};

export default SearchFormComponent;



// WEBPACK FOOTER //
// ./src/components/search-form/searchForm.component.js